import type { Banner, StaticBanner } from '../model/types';

export const isStaticBanner = (banner: Banner): banner is StaticBanner =>
  banner.type === 'STATIC_BANNER';
